module.exports = __webpack_public_path__ + "assets/filter-icon.2ac67518.svg";